export const ROME = "Europe/Rome";

export function parseApiDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const text = String(value).trim();
  if (!text) return null;
  const normalized = text.includes("T") ? text : text.replace(" ", "T");
  const hasZone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized);
  const date = new Date(hasZone ? normalized : `${normalized}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRomeDateTime(value) {
  const date = parseApiDate(value);
  if (!date) return value ? String(value) : "";
  return date.toLocaleString("it-IT", { timeZone: ROME });
}

export function toRomeDatetimeLocal(value) {
  const date = parseApiDate(value);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: ROME,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const map = Object.fromEntries(parts.filter((part) => part.type !== "literal").map((part) => [part.type, part.value]));
  const hour = map.hour === "24" ? "00" : map.hour;
  return `${map.year}-${map.month}-${map.day}T${hour}:${map.minute}`;
}

export function isSameRomeDay(value, reference = new Date()) {
  const date = parseApiDate(value);
  if (!date) return false;
  const fmt = (item) => new Intl.DateTimeFormat("en-CA", { timeZone: ROME }).format(item);
  return fmt(date) === fmt(reference);
}
